import { Controller } from "@hotwired/stimulus"
import Stimulus from "../utils/stimulus"

class Accordion extends Controller {
  static targets = [`content`, `button`, `label`, `icon`]
  static values = {
    open: { type: Boolean, default: false },
    labelOpen: { type: String, default: `Läs mer` },
    labelClosed: { type: String, default: `Läs mindre` },
  }

  connect() {
    this.updateState()
  }

  toggle() {
    this.openValue = !this.openValue
    this.updateState()
  }

  updateState() {
    if (this.hasContentTarget) {
      this.contentTarget.style.display = this.openValue ? `block` : `none`
      this.contentTarget.setAttribute(`aria-hidden`, !this.openValue)
    }

    if (this.hasLabelTarget) {
      this.labelTarget.textContent = this.openValue
        ? this.labelClosedValue
        : this.labelOpenValue
    }

    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute(`aria-expanded`, this.openValue)
    }

    // The icon rotation is handled via CSS based on data-accordion-open-value attribute on the controller element
    this.element.setAttribute(`data-accordion-open-value`, this.openValue)
  }
}

Stimulus.register(`accordion`, Accordion)
